<template>
  <div>
    <div
      v-for="(question, key) in value"
      :key="question.id"
      :class="{
        'pt-4': key !== 0 || !hasDivider,
        'border-bottom pb-5': hasDivider,
      }"
    >
      <div class="font-weight-bold d-flex align-items-center mb-2">
        {{ getTitle(question, key) }}
      </div>
      <div>
        <div v-if="isNumber(question)" class="w-25">
          <number
            v-model="question.value"
            :is-preview="isPreview"
            :is-read-only="isReadOnly"
          />
        </div>
        <div v-else-if="isTextArea(question)">
          <custom-text-area
            v-model="question.value"
            :disabled="isReadOnly"
            :maxlength="3000"
            placeholder="Escribe tu respuesta"
          />
        </div>
        <div v-else-if="isCheckVertical(question)">
          <checks
            v-model="question.value"
            :is-read-only="isReadOnly"
            :options="question.answers"
          />
        </div>
        <div v-else-if="isCheckHorizontal(question)">
          <checks
            v-model="question.value"
            horizontal
            :is-read-only="isReadOnly"
            :options="question.answers"
          />
        </div>
        <div v-else-if="isRadioVertical(question)">
          <radios
            v-model="question.value"
            :is-read-only="isReadOnly"
            :options="question.answers"
          />
        </div>
        <div v-else-if="isRadioHorizontal(question)">
          <radios
            v-model="question.value"
            horizontal
            :is-read-only="isReadOnly"
            :options="question.answers"
          />
        </div>
        <div v-else-if="isRadioWithLinkedAnswerQuestions(question)">
          <radios
            v-model="question.value"
            :is-read-only="isReadOnly"
            :options="question.answers"
          />
        </div>
        <div v-else-if="isDocument(question)">
          <div v-if="isReadOnly">
            <label class="data-label">
              Archivo
            </label>
            <action-button
              class="w-100 disabled"
              :disabled="true"
              i="fas fa-file-plus"
              text="Presione aquí para anejar documento"
              variant="outline-grey mr-3 pl-3 pr-4"
            />
          </div>
          <validation-provider
            v-else
            v-slot="{ errors }"
            class="w-100"
            name="Documento"
            rules="required"
          >
            <custom-file-input
              ref="fileInput"
              v-model="question.value"
              :accept="'.pdf'"
              :attachment-id="question.Id"
              custom-error-msg="documento es requerido"
              display-style="normal"
              :error="errors[0]"
              label="Archivo"
              label-position="left"
              :name="question.documentName"
              :on-download="() => {}"
            />
          </validation-provider>
        </div>
        <div v-else>
          -
        </div>
        <slot
          v-if="showAnswerQuestions(question)"
          :answered="question.value"
          name="selected-answer-questions"
          :parent="{ question, index: key }"
          :questions="getAnswerQuestions(question)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CustomTextArea from 'CustomTextArea';
import Number from '@/components/common/rubric/form/components/questionTypes/Number.vue';
import Checks from '@/components/common/rubric/form/components/questionTypes/Checks.vue';
import Radios from '@/components/common/rubric/form/components/questionTypes/Radios.vue';
import TYPES from '@/utils/constants/announcementQuestionnaireQuestionType';
import CustomFileInput from 'CustomFileInput';

export default {
  name: 'QuestionConfPreviewQuestions',
  components: {
    CustomTextArea,
    Number,
    Checks,
    Radios,
    CustomFileInput,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    isPreview: {
      type: Boolean,
      default: () => false,
    },
    hasDivider: {
      type: Boolean,
      default: () => false,
    },
    ordered: {
      type: Boolean,
      default: () => false,
    },
    parent: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    isNumber() {
      return ({ typeId }) => typeId === TYPES.NUMERICALTEXT;
    },
    isTextArea() {
      return ({ typeId }) => typeId === TYPES.OPENTEXT;
    },
    isCheckVertical() {
      return ({ typeId }) => typeId === TYPES.MULTIPLEVERTICAL;
    },
    isCheckHorizontal() {
      return ({ typeId }) => typeId === TYPES.MULTIPLEHORIZONTAL;
    },
    isRadioVertical() {
      return ({ typeId }) => typeId === TYPES.SIMPLEVERTICAL;
    },
    isRadioHorizontal() {
      return ({ typeId }) => typeId === TYPES.SIMPLEHORIZONTAL;
    },
    isRadioWithLinkedAnswerQuestions() {
      return ({ typeId }) => typeId === TYPES.SIMPLEWITHCHILD;
    },
    isDocument() {
      return ({ typeId }) => typeId === TYPES.DOCUMENT;
    },
    showAnswerQuestions() {
      return ({ value, childQuestions }) => value?.id && childQuestions?.length;
    },
    getAnswerQuestions() {
      return ({ childQuestions, value }) =>
        childQuestions.filter((x) => x.linkedAnswer?.id == value.id);
    },
    getTitle() {
      return ({ name }, key) => {
        if (!this.ordered) return name;

        return this.parent?.index >= 0
          ? `${key + 1}.${this.parent.index + 1} ${name}`
          : `${key + 1}. ${name}`;
      };
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/brand_variables.scss';

.ab-btn-outline-grey,
.outline-grey {
  background-color: #fafafa;
  border: #e2e2e2 solid 1px;
  color: #11291b;
}
</style>
